import { useRef, useState } from 'react';
import { FlexGrid } from '@grapecity/wijmo.react.grid';

import "bootstrap/dist/css/bootstrap.min.css";
import "@grapecity/wijmo.styles/themes/wijmo.theme.material.css";
import "../layout/DataGrid.css";

import ColumnPickerDialog from '../dialog/ColumnPickerDialog';

// 목록을 다시 읽어도(저장 · 삭제 뒤 등) 고른 행이 새 목록에 남아 있으면 그 행을 계속 고른다 — FlexGrid 는 새 목록의 첫 행으로 돌아간다.
// 행은 스키마 키로 찾고, 키가 없는 뷰는 첫 칼럼 값이 새 목록에서 한 행에만 맞을 때 그 행으로 본다
function keepSelection ( grid, getSchema ) {

    let kept;

    grid.itemsSourceChanging.addHandler ( () => {

        const schema = getSchema ();
        const item = grid.selectedItems?.[0];
        const names = schema?.keys?.length ? schema.keys : schema?.columns?.length ? [ schema.columns[0].name ] : [];

        kept = item && names.length ? names.map ( ( name ) => [ name, item[name] ] ) : undefined;

    } );

    grid.itemsSourceChanged.addHandler ( () => {

        const view = grid.collectionView;

        if ( !kept || !view ) {

            return;

        }

        const same = view.items.filter ( ( row ) => kept.every ( ( [ name, value ] ) => row[name] === value ) );

        kept = undefined;

        if ( same.length === 1 && view.currentItem !== same[0] ) {

            view.moveCurrentTo ( same[0] );

        }

    } );

}

function DataGrid ( props ) {

    const [grid, setGrid] = useState();
    const [, setColumnPicker] = useState();

    const {

        id,
        schema,
        gridRef,
        isReadOnly,
        autoGenerateColumns,
        allowSorting,
        allowPinning,
        showMarquee,
        selectionMode,
        columnGroups,

        onInitialized,
        onBeginningEdit,

        addColumnPicker,

        children,
        ...others

    } = props;

    const schemaRef = useRef ();
    schemaRef.current = schema;

    const onGridInitialized = ( grid ) => {

        keepSelection ( grid, () => schemaRef.current );

        grid.showColumnPicker = () => {

            setColumnPicker ( ( columnPicker ) => {
                columnPicker.show ();
                return columnPicker;
            } );

        }

        setGrid ( grid );

        if ( onInitialized ) {

            onInitialized ( grid );

        }

    };

    const gridProps = {

        isReadOnly: ( isReadOnly === undefined ) ? true : isReadOnly,
        autoGenerateColumns: autoGenerateColumns === undefined ? false : autoGenerateColumns,
        allowPinning: allowPinning === undefined ?  "SingleColumn" : allowPinning,
        allowSorting: allowSorting === undefined ? "MultiColumn" : allowSorting,
        showMarquee: showMarquee === undefined ? false : showMarquee,
        selectionMode: selectionMode === undefined ? "ListBox" : selectionMode,

        initialized: onGridInitialized,

        ...others

    };

    const onColumnPickerInitialized = ( columnPicker ) => {

        setColumnPicker ( columnPicker );

    };

    return (

        <FlexGrid ref={gridRef} columnGroups={columnGroups} { ...gridProps } style={ id === "uploadGrid" ? {width: "100%", height: "300px", marginTop: "16px"} :{position: "absolute", top: 0, left: 0, bottom: 0, right: 0, padding: 0, margin: 0}}>
            <ColumnPickerDialog id={id+"columnPicker"} grid={grid} schema={schema} onInitialized={onColumnPickerInitialized} />
            { children }
        </FlexGrid>        

    );

}

export { keepSelection };
export default DataGrid;
